import { useEffect } from 'react';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { useMap } from 'react-leaflet';

const Search = () => {
  const map = useMap();
  useEffect(() => {
    const provider = new OpenStreetMapProvider();

    const searchControl = new GeoSearchControl({
      provider: provider, // required
      animateZoom: true,
      autoClose: true,
      style: 'button',
      showMarker: false,
      notFoundMessage: 'Sorry, that address could not be found.',

      // showPopup: false,
      // marker: {
      //   icon: new L.Icon.Default(),
      //   draggable: false,
      // },
      // popupFormat: ({ query, result }) => result.label,
      // resultFormat: ({ result }) => result.label,
      // maxMarkers: 1,
      // retainZoomLevel: true,
      // searchLabel: 'Enter address',
      // // keepResult: false,
      // updateMap: true,
      // autoComplete: true,
      // autoCompleteDelay: 250,
      position: 'topleft',
    });
    map.addControl(searchControl);
  }, [map]);

  return null;
};

export default Search;
